import React from "react";

import { useOverlayManager } from "@hooks/useOverlayManager";

import { ContextProps } from "./DialogManager.types";
import { DialogManagerContext } from "./DialogManager.context";

export const useInitProvider = (): ContextProps => {
  const renderedManagerInstances = React.useRef(new Map<string, string>());

  const isManagerInstanceRendered = (
    dialogId: string,
    managerRenderId: string,
  ) => {
    const managerInstanceId = renderedManagerInstances.current.get(dialogId);
    if (!managerInstanceId || managerInstanceId === managerRenderId) {
      return false;
    }

    return true;
  };

  const setManagerRenderedInstance = (
    modalId: string,
    managerRenderId: string,
  ) => {
    renderedManagerInstances.current.set(modalId, managerRenderId);
  };

  const [isDialogActive, showDialog, hideDialog, getOption, getActiveDialogs] =
    useOverlayManager();

  return {
    isDialogActive,
    showDialog,
    hideDialog,
    getOption,
    getActiveDialogs,
    isManagerInstanceRendered,
    setManagerRenderedInstance,
  };
};

export const useManager = (): ContextProps => {
  const context = React.useContext(DialogManagerContext);

  if (!context) {
    throw new Error("useManager must be used within a DialogManagerProvider");
  }

  return context;
};
